import React from "react";
import ReactDOM from "react-dom";
import SearchCoursesTileComponent from "./SearchCoursesTileComponent";

const initSearchCoursesTile = () => {
  const rootElement = document.getElementById("search-courses");
  if (!rootElement) return;

  const component = (
    <SearchCoursesTileComponent
      formAction={rootElement.getAttribute("data-search-action")}
    />
  );

  const root = ReactDOM.createRoot(rootElement);
  root.render(component);
};

export default initSearchCoursesTile;
